import { faHome } from "@fortawesome/pro-light-svg-icons";
import { type PropsWithChildren } from "react";
import { Link } from "react-router-dom";

import { T } from "@repo/transifex";
import { Button } from "~/components";
import { CollectPagination } from "~/components/collect/operator/collect-pagination";
import {
  usePaginationContext,
  usePaginationDispatchContext
} from "~/components/pagination/context";
import { collectActions } from "~/providers/store/collect/actions";

/** Footer bar: Home on the left, optional right slot (e.g. pagination). */
export const Footer = ({ children }: PropsWithChildren) => (
  <div className="flex items-center justify-between gap-2.5 px-5 pb-4 pt-3">
    <Link
      to="/home"
      onClick={() => {
        collectActions.resetAllFilters();
      }}
    >
      <Button
        variant="transparent"
        icon={faHome}
        className="gap-2 px-4 py-2.5 text-base font-semibold text-interface-neutral-6"
      >
        <T _str="Home" />
      </Button>
    </Link>

    {children}
  </div>
);

/** Pagination wired to the pagination context; render inside its provider. */
export const FooterPagination = () => {
  const { currentPage, totalPages } = usePaginationContext();
  const { goToPage } = usePaginationDispatchContext();

  return (
    <CollectPagination
      currentPage={currentPage}
      totalPages={totalPages}
      onPageChange={goToPage}
    />
  );
};
